/**
 * @desc 领用单审核通过生成出库单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.test.lendOutMaster.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/lendOutMaster`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
